import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-job-queue-monitor',
  templateUrl: './job-queue-monitor.component.html',
  styleUrls: ['./job-queue-monitor.component.css']
})
export class JobQueueMonitorComponent implements OnInit {
    public setting?: Setting;

    public updating = false;

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1723))[0];
    }

    public async updateChanges() {
        if (!!this.setting) {
            try {
                this.updating = true;

                await this.loadSetting();
            } finally {
                this.updating = false;
            }
        }
    }

    private async init() {
        this.loadSetting();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    jobqueue_nbr_in_queue: string;
    jobqueue_nbr_finished: string;
    jobqueue_nbr_with_error: string;
}
